import AppLayout from './app-layout';

export default AppLayout;